import './appointment-exception-list.scss';

import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { AgendaAppointmentItemDataFragment } from '../../data/types/api/graphql';
import { CustomFormattedMessage } from '../intl/custom-formatted-message';
import {
  AppointmentExceptionListItem,
  AppointmentExceptionListItemType,
} from './appointment-exception-list-item';

type AppointmentExceptionListProps = {
  type?: AppointmentExceptionListItemType;
  items: AgendaAppointmentItemDataFragment[];
  includeHealthProfessional?: boolean;
  includePatient?: boolean;
  onClick?: (value: AgendaAppointmentItemDataFragment) => void;
};

export function AppointmentExceptionList({
  type = AppointmentExceptionListItemType.DEFAULT,
  includePatient = false,
  includeHealthProfessional = false,
  onClick,
  ...props
}: AppointmentExceptionListProps) {
  const items = useMemo(
    () => props.items.filter(option => !option.isCompleted),
    [props.items]
  );

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="appointment-exceptions-list">
      {items.map(appointment => (
        <div key={appointment.id} className="appointment-exceptions-list__item">
          <AppointmentExceptionListItem
            type={type}
            appointmentItem={appointment}
            includePatient={includePatient}
            includeHealthProfessional={includeHealthProfessional}
            onClick={onClick}
          />
        </div>
      ))}
    </div>
  );
}
